import { useQueryClient } from '@tanstack/react-query'

import { useErrandsServicePostV1IndividualsByIndividualIdErrands } from '../client/queries'
import { useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey } from '../client/queries/common'
import { PostV1IndividualsByIndividualIdErrandsData } from '../client/requests'

export type ErrandServiceType = NonNullable<
  NonNullable<PostV1IndividualsByIndividualIdErrandsData['requestBody']['serviceGroups']>[number]['services']
>[number]

export const useCreateErrand = () => {
  const queryClient = useQueryClient()

  return useErrandsServicePostV1IndividualsByIndividualIdErrands({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
      })
    },
  })
}
